import { Skeleton } from "@credit-acceptance/uikit";
import { useTranslation } from "react-i18next";

// Shaped to echo the ReviewPage shell (top bar, deal card, two-column
// Signers form, aside panels) it precedes, so auth resolving doesn't flash
// an unrelated spinner before the real layout appears.
function FullPageLoading() {
  const { t } = useTranslation();
  return (
    <div role="status" aria-live="polite" aria-label={t("common.loading")} className="flex h-dvh flex-col gap-2 p-2">
      <Skeleton.Node active className="h-12 w-full" />
      <div className="grid min-h-0 flex-1 grid-cols-1 gap-2 sm:grid-cols-[repeat(16,minmax(0,1fr))]">
        <div className="flex flex-col gap-4 sm:col-span-10 xl:col-span-12">
          <Skeleton.Node active className="h-16 w-full" />
          <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
            <Skeleton loading active paragraph={{ rows: 6 }} />
            <Skeleton loading active paragraph={{ rows: 6 }} />
          </div>
        </div>
        <div className="flex flex-col gap-2 sm:col-span-6 xl:col-span-4">
          <Skeleton.Node active className="h-40 w-full" />
          <Skeleton.Node active className="h-40 w-full" />
        </div>
      </div>
    </div>
  );
}

export default FullPageLoading;
